/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LightingInputs */

const cs_enum_lighting = /** @type {(inputs: Enum_LightingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Světlo`)
};

const en_enum_lighting = /** @type {(inputs: Enum_LightingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lighting`)
};

/**
* | output |
* | --- |
* | "Lighting" |
*
* @param {Enum_LightingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_lighting = /** @type {((inputs?: Enum_LightingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LightingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_lighting(inputs)
	return cs_enum_lighting(inputs)
});